function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 426.663h512V85.337z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M250.435 85.337H0v166.945z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M188.052 250.239l14.708-7.967-14.708-7.967c-3.434-22.308-21.06-39.934-43.366-43.366l-7.967-14.708-7.967 14.708c-22.308 3.434-39.933 21.06-43.366 43.366l-14.707 7.968 14.708 7.967c3.434 22.308 21.06 39.934 43.366 43.366l7.966 14.707 7.967-14.708c22.307-3.432 39.932-21.059 43.366-43.366zm-51.334 21.714c-16.393 0-29.682-13.289-29.682-29.682s13.289-29.68 29.682-29.68S166.4 225.88 166.4 242.273s-13.289 29.68-29.682 29.68z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M136.718 220.012l6.427 11.13h12.852l-6.426 11.131 6.426 11.13h-12.852l-6.427 11.131-6.425-11.131h-12.852l6.425-11.13-6.425-11.131h12.852z"
});

const SvgBonaire = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBonaire, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bonaire.0307040a.svg";
export { ForwardRef as ReactComponent };